import {defineStore} from "pinia";
import { StorageSerializers, useStorage } from '@vueuse/core';
import {ref} from "vue";
import InviteAPI from "@/api/InviteAPI";
import {createRequestDeduper} from '@/use/createRequestDeduper';

export const useInviteStore = defineStore('invite', () => {
  const invites = useStorage('invites', [], sessionStorage, {
    serializer: StorageSerializers.object,
  });
  const isLoading = ref<boolean>(false);
  const dedupeRequest = createRequestDeduper();
  let activeIndexKey: string | null = null;

  const clearInvites = () => {
    activeIndexKey = null;
    invites.value = null;
    isLoading.value = false;
  };

  const index = async (projectId: number, payload: any) => {
    const { params } = payload;
    const key = `invites:${projectId}:${JSON.stringify(params)}`;
    activeIndexKey = key;
    invites.value = null;

    return dedupeRequest(key, async () => {
      isLoading.value = true;
      const data = await new InviteAPI().index(projectId, params)
        .finally(() => {
          if (activeIndexKey === key) {
            isLoading.value = false;
          }
        });

      if (activeIndexKey === key) {
        invites.value = data.invites;
      }
    });
  }

  return {
    invites,
    isLoading,
    clearInvites,
    index,
  };
});
